import {fetchDataFromApi} from './apiHelper';

export const fetchFields = () => fetchDataFromApi('post', '/api/smarthub/blockedbundleslog/fields');